import React, { FC, useState } from "react";
import { Permission, useAuth, useCurrentUserData } from "../../hooks";
import { DashboardPortlet } from "../../components/dashboard-portlet";
import { MyLiveMattersContainer } from "../../containers/my-live-matters-container";
import styles from "./dashboard.css";
import { AccessControl } from "../../components/auth/access-control";
import { NotificationWrapper } from "../../containers/notifications/notifications-wrapper";
import { PmsMattersContainer } from "~/containers/pms-matters/pms-matters-container";
import { useSettings } from "~/hooks/settings";
import { Userpilot } from "userpilot";
import { extractDomainFromEmail } from "~/components/auth/helper";
import { Button } from "antd";
import { Link } from "react-router-dom";
import { QuickLinkModalContainer } from "~/containers/quick-link-modal-container";
import { PageLoading } from "~/components/page-loading";

const {
  ["container"]: containerClassName,
  ["header"]: headerClassName,
  ["content"]: contentClassName,
  ["my-alerts"]: myAlertsClassName,
  ["my-pms-matters"]: myPmsMattersClassName,
  ["my-live-matters"]: myLiveMattersClassName,
  ["my-pms-matters-body"]: myPmsMattersBodyClassName,
} = styles;

export const Dashboard: FC = () => {
  const { settings } = useSettings();
  const currentLoggedInUser = useCurrentUserData({ cache: true });
  const [openQuickLinkModal, setOpenQuickLinkModal] = useState(false);

  if (currentLoggedInUser.currentUser) {
    const args = {
      user_id: currentLoggedInUser.currentUser.userId,
      email: currentLoggedInUser.auth0User?.email ?? "",
      name: currentLoggedInUser.currentUser.displayName ?? "",
      metadata: {
        name: currentLoggedInUser.currentUser.displayName ?? "",
        email: currentLoggedInUser.auth0User?.email ?? "",
      },
      permissions: currentLoggedInUser.auth0User?.permissions,
      feeEarnerLevel: currentLoggedInUser.currentUser.feeEarnerLevelDescription,
      practiceAreaName: currentLoggedInUser.currentUser.practiceAreaName,
      tenant: extractDomainFromEmail(currentLoggedInUser.auth0User?.email ?? ""),
      company: {
        id: extractDomainFromEmail(currentLoggedInUser.auth0User?.email ?? ""),
        name: extractDomainFromEmail(currentLoggedInUser.auth0User?.email ?? ""),
        word_export_enabled: settings?.enableWordExport ?? false,
      },
      platform: navigator.userAgent.includes("Electron") ? "electron" : "web",
    };

    Userpilot.identify(currentLoggedInUser.currentUser.userId.toString(), args);
  }

  return (
    <div className={containerClassName}>
      <div className={headerClassName}>
        <h1>Welcome {currentLoggedInUser.currentUser?.displayName}</h1>
        <div>
          <Button
            type="default"
            style={{ marginRight: "8px" }}
            onClick={() => setOpenQuickLinkModal(true)}
          >
            Link {settings?.organisationPmsName ?? "PMS"} Matters
          </Button>
          <Button type="primary">
            <Link to="/create">Create Pricing Proposal</Link>
          </Button>
        </div>
      </div>
      <div className={contentClassName}>
        <div>
          <AccessControl permissions={Permission.READ_MATTER} hideAlert={true}>
            <DashboardPortlet
              className={myLiveMattersClassName}
              header={<h1>Live Matters</h1>}
              body={<MyLiveMattersContainer />}
            />
          </AccessControl>
        </div>

        <div>
          {currentLoggedInUser.currentUser?.feeEarnerId && (
            <AccessControl permissions={Permission.READ_MATTER} hideAlert={true}>
              <DashboardPortlet
                className={myPmsMattersClassName}
                body={<PmsMattersContainer pmsName={settings?.organisationPmsName ?? "PMS"} />}
                bodyClassName={myPmsMattersBodyClassName}
              />
            </AccessControl>
          )}
          <DashboardPortlet
            className={myAlertsClassName}
            header={<h1>My Alerts & Notifications</h1>}
            body={<NotificationWrapper />}
          />
        </div>
      </div>
      <QuickLinkModalContainer
        pmsName={settings?.organisationPmsName ?? "PMS"}
        forceOpen={openQuickLinkModal}
        onClose={() => setOpenQuickLinkModal(false)}
      />
    </div>
  );
};
